import {
  CALLS_CONNECTING,
  CALLS_DATA,
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  calls: []
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case CALLS_CONNECTING:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: true,
          calls: [],
        })
      };
    case CALLS_DATA:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: false,
          ...action.payload
        })
      };
    default:
      return state;
  }
};
